module.exports = __webpack_public_path__ + "media/images/emblems/Schlossrued-blason-35b2e39c459773fa27f3ace19cb13c91.png";